import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "w-full mt-6 table-auto" }
const _hoisted_4 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_8 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_9 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_10 = { class: "px-2 py-2 space-x-3 whitespace-nowrap" }
const _hoisted_11 = { key: 1 }

import { ref, computed } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";

import api from "@/api/api";
import { Student } from "@/types";
import { useUserStore } from "@/store/user";
import { userHasRole } from "@/utils/roles";
import RoleGuard from "@/components/RoleGuard.vue";
import ClubStudentRouterButton from "@/components/clubs/ClubStudentRouterButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberOutcomesIndex',
  async setup(__props) {

let __temp: any, __restore: any

const { user, facilitatorRoles, trainerRoles, orgRoles } = storeToRefs(useUserStore());

const query = ref("");
const members = ref([] as Student[]);

const filteredMembers = computed(() => {
  return query.value !== ""
    ? members.value.filter(member => member.first_name.toLowerCase().includes(query.value.toLowerCase()) || member.last_name.toLowerCase().includes(query.value.toLowerCase()))
    : members.value;
});

async function fetchMembersList() {
  if (!user.value.has_smartsurvey_access) return;

  if (userHasRole(user.value.roles, ["admin"])) {
    members.value = (await api.students.listMembers()).data.students;
  } else if (userHasRole(user.value.roles, ["facilitator-organisation"])) {
    members.value = (await api.students.listMembersByOrganisation()).data.members;
  } else {
    members.value = (await api.students.listMembersByFacilitator(user.value.id)).data.members;
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchMembersList())),
  await __temp,
  __restore()
);

if (!userHasRole(user.value.roles, [...facilitatorRoles.value, ...orgRoles.value])) {
  window.location.href = "/dashboard";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('member-outcomes')
      }, null, 8, ["title"])
    ]),
    (_unref(user).has_smartsurvey_access && _unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
              placeholder: "Search ...",
              required: ""
            }, null, 512), [
              [_vModelText, query.value]
            ])
          ]),
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", _hoisted_4, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("name")), 1),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("brick-club")), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("actions")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredMembers), (member) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b border-gray-400",
                  key: member.id
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(member.first_name) + _toDisplayString(member.middle_name ? ' ' + member.middle_name : '') + " " + _toDisplayString(member.last_name), 1),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(member.clubs[0].name), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(ClubStudentRouterButton, {
                      student: member,
                      to: `/dashboard/club-member-outcomes/${member.id}`
                    }, null, 8, ["student", "to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(RoleGuard, {
            roles: [..._unref(facilitatorRoles), ..._unref(trainerRoles), 'certified-facilitator-trainee', 'facilitator-organisation']
          }, {
            default: _withCtx(() => [
              _createVNode(AlertCard, {
                type: "warning",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("no-smartsurvey-access-description")), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["roles"])
        ]))
  ], 64))
}
}

})